import Vue from 'vue'

export default function excludeStudents({
  studentId,
  groupId,
  exit,
  comment,
  is_trial,
}) {
  const proxy = process.env.VUE_APP_PROXY
  const api_uri = process.env.VUE_APP_API_URI

  let url =
    proxy +
    api_uri +
    '/students/' +
    studentId +
    '/group/' +
    groupId +
    '/exclude'
  return Vue.http
    .put(
      url,
      { exit, comment, is_trial },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    .then(response => response.json())
    .catch(() => {
      throw 'Ошибка сохранения'
    })
}
